import reducer from './change-password-reducer';

export default reducer;
export { initialState } from './change-password-reducer';

export * from './change-password-actions';
